import { render, staticRenderFns } from "./TrainingType.vue?vue&type=template&id=b2d0ae2a&scoped=true&"
import script from "./TrainingType.vue?vue&type=script&lang=js&"
export * from "./TrainingType.vue?vue&type=script&lang=js&"
import style0 from "./TrainingType.vue?vue&type=style&index=0&id=b2d0ae2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d0ae2a",
  null
  
)

export default component.exports